// Added by Sejune Oh on 2020-03-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core'
import cn from 'classnames'

// Color
import { COLOR_BLUE, FONT_COLOR_TITLE, FONT_COLOR_DISABLED, RED_COLOR } from '@/styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface ButtonProps {
  /** Button type  */
  type?: 'confirm' | 'cancel' | 'default'
  /** Button disabled */
  disabled?: boolean
  /** Button click evt handler */
  onBtnClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  /** Button styles from parent */
  customClassName?: string
  /** WC용 Styles  */
  classes?: any
  /** Tooltop용 title */
  title?: string
  /** auto focus */
  autoFocus?: boolean
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 *  Worklist UI에서 사용하는 Cummon Button
 */
const Button: FC<ButtonProps> = ({
  type = 'default',
  disabled = false,
  onBtnClick,
  customClassName,
  classes: webComponentClassses,
  title,
  children,
  autoFocus = false,
  ...rest
}) => {
  const classes = webComponentClassses
    ? webComponentClassses['button']
    : makeStyles(() => createStyles({ ...customStyles }))()
  return (
    <button
      title={title}
      disabled={disabled}
      className={cn(classes.btn, customClassName, {
        [classes.cancelBtn]: type === 'cancel',
        [classes.confirmBtn]: type === 'confirm',
      })}
      onClick={onBtnClick}
      autoFocus={autoFocus}
      {...rest}
    >
      {children}
    </button>
  )
}

export const customStyles: Record<string, any> = {
  btn: {
    overflow: 'hidden',
    outline: 'none',
    font: 'inherit',
    fontSize: '11px',
    boxSizing: 'border-box',
    height: '30px',
    width: '80px',
    border: '1px solid #000',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#383838',
    color: FONT_COLOR_DISABLED,
    cursor: 'not-allowed',
    '&:enabled': {  
      color: FONT_COLOR_TITLE,
      cursor: 'pointer',
      '&:hover': {
        color: COLOR_BLUE,
      },
      '&:focus': { backgroundColor: 'rgb(17, 64, 97)' },
      '&:active': {
        backgroundColor: 'rgb(19, 80, 119)',
      },
    },
  },
  cancelBtn: {
    backgroundColor: RED_COLOR,
  },
  confirmBtn: {
    backgroundColor: '#114061',
  },
}

export default Button
